import { render, staticRenderFns } from "./MypageUserInitConfirmPage.vue?vue&type=template&id=71f4f462&scoped=true"
import script from "./MypageUserInitConfirmPage.vue?vue&type=script&lang=ts"
export * from "./MypageUserInitConfirmPage.vue?vue&type=script&lang=ts"
import style0 from "./MypageUserInitConfirmPage.vue?vue&type=style&index=0&id=71f4f462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f4f462",
  null
  
)

export default component.exports